import type { Uuid } from '@nodes/app-v2.1.0'
import type { BaseProps } from '../node/definition'

export default () =>
	({
		subscribes: new Map(),
	}) satisfies Store

export type Store = BaseProps & {
	response?: any
	subscribes: Subscribes
}

type Subscribes = Map<LiveQueryResult, Uuid> // liveQuery: liveUuid
export type SItem = Record<string, { id: string }>
export type LiveQuery = (response: any) => LiveQueryResult
export type LiveQueryResult = { query: string; refetch: boolean; signal: boolean }
